<template>
  <section v-if="Train && lang[5]">
    <Title :title-name="title.Train.titleName" :title-link="title.Train.titleLink" />
    <div class="train">
      <div class="container">
        <div class="row">
          <div class="col-4 logo-train">
            <img src="@/assets/images/trains-logo.jpg" />
          </div>
          <div class="train-voucher-info col-8">
            <p class="font-weight-bold">
              {{ lang[5].SFS_LANG_ROW_2 }}
              <span>{{ pax.first_name }} {{ pax.last_name }}</span>
            </p>
          </div>
          <div class="col-12" style="margin: 14pt 0">
            <p>
              {{ lang[5].SFS_LANG_ROW_3 }}:
              <span>{{ Train.stationname_from }}</span>
            </p>
            <p>
              {{ lang[5].SFS_LANG_ROW_4 }}:
              <span>{{ Train.stationname_to }}</span>
            </p>
            <p>
              {{ lang[5].SFS_LANG_ROW_5 }}:
              <span>{{ Train.train_travel_date }}</span>
            </p>
            <p>
              {{ lang[5].SFS_LANG_ROW_6 }}
            </p>
          </div>
        </div>
        <div class="text-center">
          {{ lang[5].SFS_LANG_ROW_11 }}
        </div>
        <div class="train-voucher-info">
          <p>
            <strong>{{ lang[5].SFS_LANG_ROW_7 }}</strong
            ><br />
            <i>{{ lang[5].SFS_LANG_ROW_8 }}</i>
          </p>
        </div>
        <div class="train-voucher-info">
          <p>
            <strong>{{ lang[5].SFS_LANG_ROW_9 }}</strong
            ><br />
            <i>{{ lang[5].SFS_LANG_ROW_10 }}</i>
          </p>
        </div>
      </div>
    </div>
    <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
  </section>
</template>

<script>
import '@/assets/scss/modules/Train.scss'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'Train',
  components: { ButtonDownloadVoucher, Title },
  data() {
    return {
      nameVoucher: 'Train',
      canDownload: false
    }
  },
  computed: {
    ...mapGetters({
      Train: 'Train/Train'
    })
  },
  watch: {
    Train: function (newVal) {
      this.canDownload = newVal && newVal.stationname_from != '' ? true : false
    }
  },
  mounted() {
    this.$store.dispatch('Train/getTrain')
  }
}
</script>
